import { ConvergenceAuthMethod } from '../../model'

const CASH_AUTH_METHOD_TAGS: Record<ConvergenceAuthMethod, string> = {
  [ConvergenceAuthMethod.MobileRedirect]: 'mobile-redirect',
  [ConvergenceAuthMethod.DesktopRedirect]: 'desktop-redirect',
  [ConvergenceAuthMethod.QrCode]: 'qr-code',
}

interface CashAuthJourneyTagContext {
  cashAuthJourneyId?: string
  cashAuthMethod?: ConvergenceAuthMethod
  isAuthorized: boolean
  existingTags?: readonly string[]
}

export const getCashAuthJourneyTags = ({ cashAuthJourneyId, cashAuthMethod, isAuthorized, existingTags = [] }: CashAuthJourneyTagContext): string[] => {
  const values = {
    cashAuthJourneyId,
    cashAuthMethod: cashAuthMethod === undefined ? undefined : CASH_AUTH_METHOD_TAGS[cashAuthMethod],
    cashAuthResult: isAuthorized ? 'authorized' : undefined,
  }

  return Object.entries(values).flatMap(([key, value]) =>
    value === undefined || value === '' || existingTags.some((tag) => tag.startsWith(`${key}:`)) ? [] : [`${key}:${value}`]
  )
}

export const getAuthorizedCashHandoffTags = (handoffTags: readonly string[], existingTags: readonly string[]): string[] => {
  const preservedTags = handoffTags.filter((tag) => (tag.startsWith('cashAuthJourneyId:') || tag.startsWith('cashAuthMethod:')) && !existingTags.includes(tag))
  return existingTags.some((tag) => tag.startsWith('cashAuthResult:')) ? preservedTags : [...preservedTags, 'cashAuthResult:authorized']
}
